import gql from "graphql-tag";

export const GET_EPAPERS = gql`
  query getEpapers($skip: Int!, $limit: Int) {
    getEpapers(skip: $skip, limit: $limit) {
      _id
      heading
      permalink
      title
      file
      thumbnail
      date
      createdDate
    }
  }
`;

export const GET_EPAPER_BY_PERMALINK = gql`
  query getEpaper($permalink: String!) {
    getEpaper(permalink: $permalink) {
      _id
      heading
      permalink
      title
      file
      thumbnail
      date
      createdDate
    }
  }
`;
